import { Api } from "@/plugins/api"

export const initFormulaire = (endpoint, contactId, sasBuilderBuildParam, estFormulairePublic) => {
  if (estFormulairePublic) {
    return Api.post(endpoint + "/init", sasBuilderBuildParam)
  } else {
    return Api.post(endpoint + "/init/" + contactId, sasBuilderBuildParam)
  }
}

export const getSas = (endpoint, sasId) => {
  return Api.get(endpoint + sasId)
}

export const submitSas = (endpoint, sasId) => {
  return Api.post(`${endpoint}/submit/${sasId}`)
}
